// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"049f547e","272":"6976abca","712":"f4d51717"}[chunkId] + ".chunk.js";
};